import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
// 🚀 INYECTADO: Desbloquea la directiva [(ngModel)] en componentes Standalone
import { FormsModule } from '@angular/forms'; 

import { Customers } from '../../Customers/models/customers'; 
import { CustomersService } from '../../Service/customers-service';
import { CustomerEdit } from '../customer-edit/customer-edit';
import { ToastService } from '../../Service/toast-service'; 
import { AuthService } from '../../Service/auth'; // Ajusta la ruta de tus carpetas
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-list',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLinkActive, RouterLink, FormsModule],
  templateUrl: './customer-list.html',
  styleUrl: './customer-list.css',
})
export class CustomerList implements OnInit {
  // Tus variables y arreglos unificados que ya revisamos a puro golpe de ojo...
  customers: Customers[] = [];
  filtroTexto: string = '';
  customersFiltrados: Customers[] = []; // Variable que alimenta el *ngFor

  // =========================================================================
  // 🎛️ VARIABLES CORE PARA TU NUEVA PAGINACIÓN REACTIVA DE ALTO RENDIMIENTO
  // =========================================================================
  paginaActual: number = 1;
  registrosPorPagina: number = 10; // Límite exacto de renglones por rejilla
  totalPaginas: number = 1;

  // Hacemos visible la librería Math para que la plantilla HTML no arroje errores ts(2339)
  protected readonly Math = Math;

  constructor(
    private customerService: CustomersService,
    public dialog: MatDialog,
    public toastService: ToastService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ){

    
  }

  ngOnInit(): void {
    // =========================================================================
    // 🛡️ RECEPTOR DE ESTADOS ASÍNCRONOS MULTI-TENANT (CICLO SEGURO)
    // SOLUCIÓN: Usamos history.state para rescatar el mensaje del alta.
    // Al ejecutarlo aquí, el componente ya nació de forma legal y sanamos 
    // el error de 'ASSERTION ERROR' al 100% libre de parpadeos.
    // =========================================================================
    const estadoRuta = typeof window !== 'undefined' ? history.state : null;

    if (estadoRuta && estadoRuta['mostrarAlertaExito']) {
      // Disparamos tu Toast flotante verde corporativo sobre el grid
      this.toastService.showSuccess('Registro Exitoso', estadoRuta['mensajeToast']);
      
      // Forzamos a Angular a redibujar el contenedor de Toasts de forma legal
      this.cdr.detectChanges();
    }

    // 🚀 TU LLAMADA TRADICIONAL HISTÓRICA INTACTA
    this.listCustomers();    
  }

  listCustomers(): void {
    console.log('>>> [ERP JDE] Descargando catálogo maestro de clientes desde el puerto 8085...');
    
    // Invocamos tu servicio HTTP original
    this.customerService.getCustomerList().subscribe({
      // 🚀 TIPADO INTEGRADO: Recibe el arreglo estructurado de tu interfaz real
      next: (data: Customers[]) => {
        // this.customers = data;
        this.customers = data.map((c: any) => {
          const identidad = c.identidadGlobal;
          if (identidad) {
            c.name = identidad.nameAlpha || c.name || '';
            c.razonSocial = identidad.nameAlpha || c.razonSocial || '';
            // Se mapea 'tax_id' (taxId en Java) al campo 'rfc' que espera el HTML
            c.rfc = identidad.taxId || c.rfc || '';
            c.email = identidad.email || c.email || '';
            c.telefonoDF = identidad.phone || c.telefonoDF || '';
          }
          return c;
        });
         
        // 💡 POBLADO INICIAL AUTOMÁTICO: Clonamos los 25 registros en el mismo microsegundo.
        // Esto garantiza que el grid nazca lleno en cuanto el asesor entra a la pantalla,
        // y la caja de búsqueda superior servirá para recortar sobre esta base.

        //this.customersFiltrados = [...data]; 
        // Poblado inicial de la cuadrícula con los datos ya aplanados
        this.customersFiltrados = [...this.customers];

        console.log('>>> [ERP JDE] Sincronización exitosa. Registros cargados en el Grid:', this.customersFiltrados.length);
        
        // 🌟 CRÍTICO PAGINACIÓN: Recalcula las páginas del grid tras cargar los datos
        this.paginaActual = 1;
        this.calcularTotalPaginas();

        // Forzamos el redibujado instantáneo de la UI para pintar las celdas de golpe
        this.cdr.markForCheck();
        this.cdr.detectChanges(); 
      },
      error: (err) => {
        console.error('Error fatal al recuperar el catálogo de clientes corporativos:', err);
        this.toastService.showDanger('Fallo de Sincronización', 'No se pudo conectar con la tabla f0101 del servidor.');
        this.cdr.detectChanges();
      }
    });
  }

  // =========================================================================
  // REFACTORIZACIÓN EN EL BORRADO: USO DEL AN8 CORPORATIVO JDE
  // =========================================================================
  deleteCustomer(an8: number): void {
    // 💡 MEJORA DE FUNCIONALIDAD: Añadimos una confirmación nativa para evitar borrados accidentales
    const confirmar = confirm(`¿Estás seguro de que deseas eliminar permanentemente al cliente con AN8: ${an8}?`);
    if (!confirmar) return;

    console.log('Despachando solicitud de borrado para el AN8:', an8);
    this.customerService.deleteCustomerById(an8).subscribe({
      next: () => this.listCustomers(),
      error: (err) => console.error('No se pudo eliminar el cliente corporativo:', err)
    });
  }

  editCustomer(customer: Customers): void {
    const dialogRef = this.dialog.open(CustomerEdit, {
      data: customer, // Pasa el objeto cliente completo al modal de edición
      width: '900px', 
      height: '1000px', 
      panelClass: 'custom-dialog-container' 
    });

	  dialogRef.afterClosed().subscribe(result => {
      // Validamos que el diálogo retorne un cliente modificado válido (HTTP 200 Exitoso)
      if (result && result.an8) {
        
        // =========================================================================
        // COMBINADO: Tu Refactorización Dinámica en Memoria mediante AN8
        // =========================================================================
        const index = this.customers.findIndex(c => c.an8 === result.an8);
        if (index !== -1) {
          //this.customers[index] = result;
          // 💡 LA CLAVE DEL ENGRANJE: Clonamos el resultado para romper la referencia antigua 
          // y obligar a Angular a entender que el renglón cambió por completo.
          this.customers[index] = { ...result };
        }

        // Tus logs preventivos de auditoría en consola mantenidos al 100%
        console.log("AN8 del cliente editado e indexado:", this.customers[index].an8);
        console.log("Email de correspondencia actualizado:", this.customers[index].automaticEmail);
        console.log("Resultado del payload devuelto por el modal:", result.an8, result.name, result.email);

        // =========================================================================
        // 🚀 FIX: FORZAMOS EL REDIBUJADO VISUAL Y DISPARAMOS EL TOAST
        // =========================================================================
        // Le avisamos a Angular que la tabla cambió en memoria para que actualice el grid al instante
        this.cdr.markForCheck();
        this.cdr.detectChanges();

        // =========================================================================
        // 💡 CORREGIDO Y UNIFICADO: El listado principal dispara el Toast Verde Corporativo
        // =========================================================================
        this.toastService.showSuccess(
          'Actualización Exitosa', 
          `Los cambios para el cliente corporativo [${result.name}] con AN8 [${result.an8}] se guardaron correctamente.`
        );

        // Refresca la lista desde el servidor para garantizar sincronización de auditorías y fechas
        this.listCustomers();

      } else {
        // Tu log de respaldo por si el usuario presionó 'Cancelar' o cerró con ESC
        console.warn(">>> ALERTA: El diálogo de edición se cerró sin realizar modificaciones (Result vino nulo o cancelado).");
      }
    });
  }

  trackByAn8(index: number, customer: Customers): number {
    return customer.an8;
  }

  ejecutarCerrarSesion(): void {
    // 1. Destruimos la sesión en el almacenamiento local
    this.authService.logout();

    // 2. Disparamos la alerta de confirmación visual flotante
    this.toastService.showSuccess(
      'Sesión Cerrada',
      'Ha salido del sistema de forma segura. El portal se encuentra listo para cambio de usuario.'
    );

    // 3. Devolvemos la tablet al Login de inmediato de forma reactiva
    this.router.navigate(['/login']);
    this.cdr.detectChanges();
  }  

   /**
   * 🔍 MOTOR DE BÚSQUEDA AUDITADO CON LOGS (100% TIPADO CON CUSTOMERS):
   * Analiza en tiempo real el comportamiento del filtro multi-columna.
   */
  filtrarClientes(): void {
    console.group('👥 [LOG FILTRO_CLIENTES] Iniciando evaluación en caliente');
    
    const busqueda = this.filtroTexto.trim().toUpperCase();
    console.log('Texto capturado en el Input (Sanitizado):', `"${busqueda}"`);
    console.log('Total de registros en el arreglo maestro (this.customers):', this.customers.length);

    if (!busqueda) {
      console.log('💡 Buscador vacío. Restaurando el 100% de los clientes en la cuadrícula.');
      this.customersFiltrados = [...this.customers];
      this.paginaActual = 1;
      this.calcularTotalPaginas();
      console.groupEnd();
      this.cdr.detectChanges();
      return;
    }

    // 🚀 CORREGIDO: Declaramos explícitamente el tipo (c: Customers) para Ivy
    this.customersFiltrados = this.customers.filter((c: Customers, index: number) => {
      
      // Casteamos temporalmente a cualquier tipo para leer las propiedades dinámicas del DTO
      const clienteAny = c as any;
      
      const an8Str = clienteAny.an8 ? clienteAny.an8.toString() : '';
      const nombre = clienteAny.nameAlpha || clienteAny.alph || clienteAny.name || ''; // clienteAny.razonSocial ||
      const rfc = clienteAny.taxId || clienteAny.tax || clienteAny.rfc || '';

      const matchAn8 = an8Str.includes(busqueda);
      const matchNombre = nombre.toUpperCase().includes(busqueda);
      const matchRfc = rfc.toUpperCase().includes(busqueda);

      if (index < 3) {
        console.log(`🧐 Analizando fila #${index + 1} [AN8: ${an8Str}]:`, {
          nombreEvaluado: nombre,
          rfcEvaluado: rfc,
          matchAn8,
          matchNombre,
          matchRfc
        });
      }

      return matchAn8 || matchNombre || matchRfc;
    });

    console.log('✅ Filtrado concluido. Registros que pasaron la compuerta visual:', this.customersFiltrados.length);
    console.groupEnd();

    this.paginaActual = 1;
    this.calcularTotalPaginas();

    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }  

  calcularTotalPaginas(): void {
    // Evitamos divisiones por cero si el filtro de búsqueda no arroja resultados
    this.totalPaginas = Math.ceil(this.customersFiltrados.length / this.registrosPorPagina) || 1;
    this.cdr.detectChanges();
  }

  cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      console.log('>>> [PREFS JDE] Conmutando vista de clientes a la página:', this.paginaActual);
      this.cdr.detectChanges();
    }
  }  

  /**
   * 💡 LA COMPUERTA RECTANGULAR RECTACTIVA:
   * Recorta el array filtrado en caliente usando .slice() para la vista HTML.
   */
  get customersPaginados(): any[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    return this.customersFiltrados.slice(inicio, fin); // Cambia 'customersFiltrados' por el nombre de tu array de filtros
  }  

}